/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const target = event.target;
  console.log(event, 'EVENT');
  if (event.target.dataset.toggleTarget) {
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    tabToggle(event);
  }
  if (event.target.dataset.modalTarget) {
    modalPop(event);
  }
  if (event.target.hasAttribute('data-toggle-reset')) {
    // console.log('reset toggles');
    const toggles = document.querySelectorAll('[data-toggle-target]');
    const targets = document.querySelectorAll('[data-toggle-content]');
    toggles.forEach((toggle) => {
      toggle.classList.remove('active');
    });
    targets.forEach((toggle) => {
      toggle.classList.remove('active');

      setTimeout(function () {
        toggle.style.height = '0px';
      }, 500);
    });
  }

  if (event.target.hasAttribute('data-toggle-close')) {

    const target = event.target.dataset.toggleClose;
    console.log('close toggle', target);
    document
    .querySelector(`[data-toggle-target="${target}"]`)
    .classList.remove('active');
    document
    .querySelector(`[data-toggle-content="${target}"]`)
    .classList.remove('active'); 
  }




  if (event.target.hasAttribute('data-close')) {
    console.log('eventclose', event);
    const target = event.target.dataset.close;
    document
    .querySelector(`[data-toggle-target="${target}"]`)
    .classList.remove('active');
    document
    .querySelector(`[data-toggle-content="${target}"]`)
    .classList.remove('active');
     event.target.removeAttribute('data-close');
  } 
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      const target = item.dataset.closeOutside;
      document
      .querySelector(`[data-toggle-target="${target}"]`)
      .classList.remove('active');
      document
      .querySelector(`[data-toggle-content="${target}"]`)
      .classList.remove('active');

       document.querySelector('[data-close]').removeAttribute('data-close');
    });

    //console.log('Escape key pressed');
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();

  const target = event.target.dataset.toggleTarget;
  const body = document.querySelector('body');

  if (event.target.hasAttribute('data-reset')) {
    const resetToggles = document.querySelectorAll('[data-toggle-target][data-reset]');
    
    resetToggles.forEach((toggle) => {
      const isSameTarget = toggle.dataset.toggleTarget === target;
      toggle.classList.toggle('active', isSameTarget);
      
      if (!isSameTarget) {
        const contentToClose = document.querySelector(`[data-toggle-content="${toggle.dataset.toggleTarget}"]`);
        if (contentToClose) {
          contentToClose.classList.remove('active');
          contentToClose.style.height = '0px';
          contentToClose.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  const toggleContainers = document.querySelectorAll(`[data-toggle-content="${target}"]`);

  toggleContainers.forEach((group) => {
    const isOpening = !group.classList.contains('active');

    if (isOpening) {
      // 1. Update Toggle Buttons
      const toggles = document.querySelectorAll('[data-toggle-target]');
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.add('active');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      if (event.target.hasAttribute('data-close-outside')) {
        const closeTarget = event.target.dataset.closeOutside;
        body.setAttribute('data-close', closeTarget);
      }
      
      group.setAttribute('aria-hidden', 'false');
      group.classList.add('active');

      // 2. Measure height
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      // 3. Double rAF forces Firefox to register the 0px start state before animating
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          group.style.height = height;
        });
      });

      // 4. Listen for transition end (ONLY for height, and ONLY on this element)
      group.addEventListener('transitionend', function handleOpenEnd(e) {
        if (e.target === group && e.propertyName === 'height') {
          group.style.height = 'auto'; // Firefox Fix for dynamic content
        }
      }, { once: true });
      
    } else {
      // CLOSING
      const toggles = document.querySelectorAll('[data-toggle-target]');
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.remove('active');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      body.removeAttribute('data-close');
 
      // 1. Set explicit height so CSS transition triggers
      group.style.height = group.offsetHeight + 'px';
      
      // 2. Force browser to acknowledge the explicit height (Reflow trigger)
      group.offsetHeight; 

      // 3. Double rAF to trigger smooth transition to 0px
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          group.style.height = '0px';
        });
      });

      // 4. Strict transition end listener
      let handled = false;
      function finalize(e) {
        if (handled) return;
        // Ensure it's the height transition ending on the group itself, not a child
        if (e && (e.target !== group || e.propertyName !== 'height')) return;
        
        handled = true;
        group.classList.remove('active');
        group.setAttribute('aria-hidden', 'true');
      }

      group.addEventListener('transitionend', finalize, { once: true });
      setTimeout(() => finalize(), 450); // Fallback slightly longer than CSS transition
    }
  });
}



/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  const isMobileToggle = event.target.hasAttribute('data-mobile-toggle') && window.innerWidth < 749;

  if (isMobileToggle) { 
    if (event.target.classList.contains('active')) {
      // Close the tab if it's already active
      event.target.classList.remove('active');
      document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
        .forEach((content) => content.classList.remove('active')); 
    } else {
      // Open the tab
      tabGroups.forEach((group) => group.classList.remove('active'));
      event.target.classList.add('active');
      document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
        .forEach((content) => content.classList.add('active')); 
    }
  } else {
    // For non-mobile toggles
    tabGroups.forEach((group) => {
      console.log(group, ' GROUP');
      group.classList.remove('active');
  
    });
    event.target.classList.add('active');
    document.querySelectorAll(`[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`)
      .forEach((content) => {
        content.classList.add('active')

        const sliders = content.querySelectorAll('.bd-slider'); 
        sliders.forEach((slider) => {
          const sliderData = Flickity.data(slider);
          console.log(sliderData, 'Slider FLickity');
          sliderData.resize();
        }); 
       });

    

  }
}

// MODAL TOGGLING
function modalPop(event) {
  console.log(event);
  event.preventDefault();
  const target = event.target.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  ); 
  console.log(modalContent, 'MODAL CONTENT'); 
  const closeBtns = modalContent.querySelectorAll('[data-close]'); 
  const modalSlider = modalContent.querySelector('.bd-slider');

  /* STUFF FOR PRODUCT QUOTE */
  const productContainer = event.target.closest('[data-product-item]');
  const quoteContainer = event.target.closest('[data-quote-item]'); 
   
  if (productContainer) { 
    console.log('product-container', productContainer);
    const productTitle = productContainer.dataset.productTitle; 
    const productImage = productContainer.querySelector('img');
    if (productImage) {
      modalContent.classList.add('with-image');
      console.log('with-image');
      localStorage.setItem('quoteProduct', productTitle);
      localStorage.setItem('quoteImageSrc', productImage.src);
      localStorage.setItem('quoteImageSrcset', productImage.srcset);
       
      modalContent.querySelector('[data-product-image] img').src =
        productImage.src;
      modalContent.querySelector('[data-product-image] img').srcset =
        productImage.srcset;
      modalContent.querySelector('[data-product-title]').value = productTitle;
      modalContent.querySelector('[data-quote-display-title]').innerHTML =
        productTitle;
    } else {
      console.log('without-image'); 
      quoteHeader ? quoteHeader.innerHTML = 'Request a Quote/Contact Us': null;
    }
  } 
  if (quoteContainer) {
    console.log('non-product quote');
    modalContent.classList.add('general-quote');
    quoteHeader ? quoteHeader.innerHTML = 'Request a Quote/Contact Us': null;
  }

  /* END STUFF FOR PRODUCT QUOTE */
  repositionModal(modalContent);
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      closeModal(modalContent);
    });
  });

  window.onclick = function (event) {
    if (event.target == modalContent) {
      closeModal(modalContent);
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      closeModal(modalContent);
    }
  });
  if (modalSlider) {
    // Do stuff later if there is a slider in the modal
  }
}

function stopVideos() {
  document.querySelectorAll('iframe').forEach((v) => {
    v.src = v.src;
  });
  document.querySelectorAll('video').forEach((v) => {
    v.pause();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  document.querySelector('body').classList.remove('overflow-hidden');
  const cookie = modal.dataset.cookieModal ? modal.dataset.cookieModal : false;
  const days = modal.dataset.cookieExpires ? modal.dataset.cookieExpires : 5;
  if (cookie) {
    setCookie(cookie, 'seen', days);
  }
  stopVideos();
  restoreElement(modal);


    /* STUFF FOR PRODUCT QUOTE */
    localStorage.removeItem('quoteProduct');
    localStorage.removeItem('quoteImageSrc');
    localStorage.removeItem('quoteImageSrcset');
    modal.classList.remove('with-image');
    modal.querySelector('[data-product-image] img').src =
        '';
      modal.querySelector('[data-product-image] img').srcset =
       '';
      modal.querySelector('[data-product-title]').value = '';
      modal.querySelector('[data-quote-display-title]').innerHTML =
        '';
}

function repositionModal(elementToMove) {
  document.body.insertBefore(elementToMove, document.body.firstChild);
}

// To restore the element to its original position
function restoreElement(elementToMove) {
  const originalParent = elementToMove.parentNode;
  const originalNextSibling = elementToMove.nextSibling;
  if (originalNextSibling) {
    originalParent.insertBefore(elementToMove, originalNextSibling);
  } else {
    originalParent.appendChild(elementToMove);
  }
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}




 
  const limitlists = document.querySelectorAll('ul[data-limit]');

  limitlists.forEach(list => {
    const limit = parseInt(list.getAttribute('data-limit'), 10);
    const items = Array.from(list.querySelectorAll('li'));
    
    // If there are fewer items than the limit, do nothing
    if (items.length <= limit) return;

    // Hide items that exceed the limit
    const itemsToHide = items.slice(limit);
    itemsToHide.forEach(item => item.classList.add('hide'));

    // Create the toggle button
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'view-more-btn  small-size gpa025';
    button.innerHTML = `View More <span class="btn-arrow">↓</span>`;

    // Insert the button right after the UL
    list.insertAdjacentElement('afterend', button);

    // Toggle logic
    button.addEventListener('click', () => {
      const isExpanded = button.classList.contains('is-expanded');

      if (isExpanded) {
        // Collapse
        itemsToHide.forEach(item => item.classList.add('hide'));
        button.classList.remove('is-expanded');
        button.innerHTML = `View All <span class="btn-arrow">↓</span>`;
      } else {
        // Expand
        itemsToHide.forEach(item => item.classList.remove('hide'));
        button.classList.add('is-expanded');
        button.innerHTML = `View Less <span class="btn-arrow">↑</span>`;
      }
    });
  });
 